import React, { useState, useRef, useEffect } from "react";
import { endPoints } from "../../constant/Environment";
import {
  addData,
  deleteData,
  getAllData,
  getAllFilterData,
} from "../../Utility/API";
import { Modal, Form, Button } from "react-bootstrap";

import { useNavigate,useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Actions } from "../../redux/Actions/Actions";
import Toaster from "../../components/Toast";
import Loader from "../../components/Loader";
import { ErrorToast, SuccesToast } from "../../components/Toast/message";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import FormControlLabel from "@mui/material/FormControlLabel";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import DateTimePicker from "react-datetime-picker";
import 'react-datetime-picker/dist/DateTimePicker.css';
import Switch from "@mui/material/Switch";
import moment from "moment/moment";

const CreatePopup = (props) => {
  const { onClose, editData, open, ...other } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [title, setTitle] = useState("");
  const [des, setDescription] = useState("");
  const [price, setPrice] = useState("");
  const [code, setCode] = useState("");
  const [playerCount, setPlayerCount] = useState("");
  const [isActive, setIsActive] = useState(false);
  const [image, setImage] = useState("");
  const [webimage,setWebImage] = useState("");
  const [link, setLink] = useState("");
  const [cutoffdate, setCutoffdate] = useState("");
  const [cutofftime, setCutofftime] = useState("");
  const [startdate, setStartdate] = useState("");
  const [startTime, setStartTime] = useState("");
  const[sort,setSort] = useState("");
  const[starting,setStarting] = useState("");
  const[ending,setEnding] = useState("");
  const[startTiming,setStartTiming] = useState("");
  const[endTiming,setEndTiming] = useState("");
  const[userlist,setUserList] = useState(" ");
  const [customerIds, setCustomerIds] = useState('');


  const params = useParams();

  useEffect(()=>{


    if (startdate || startTime) {
    
      setStarting(startdate.concat("",startTime));

      setStartTiming(moment(starting, 'YYYY-MM-DDHH:mm').format('YYYY-MM-DDTHH:mm:ss'));

    }

    if (cutoffdate || cutofftime) {

     setEnding(cutoffdate.concat("",cutofftime));

     setEndTiming(moment(ending, 'YYYY-MM-DDHH:mm').format('YYYY-MM-DDTHH:mm:ss'));

    }

  })


  React.useEffect(() => {
    if (open) {
      // console.log("data",editData,Object.keys(editData).length);

      if(Object.keys(editData).length===0){
        
      setTitle(editData?.title);
      setDescription(editData?.description);
      setIsActive(editData?.isActive);
      setImage(editData?.mobile_image);
      setWebImage(editData?.web_image);
      setUserList(editData?.user_list);
      setSort(editData?.login_attempt);
      setLink(editData?.link);
      setCutoffdate("");
      setCutofftime("");
      setStartdate("");
      setStartTime("");        
      }
      else{

        setTitle(editData?.title);
        setDescription(editData?.description);
        setIsActive(editData?.isActive || false);
        setImage(editData?.mobile_image);
        setWebImage(editData?.web_image);
        setUserList(editData?.user_list);
        setSort(editData?.login_attempt);
        setLink(editData?.link);
        setCutoffdate(moment(editData?.cuttoffTime).format('YYYY-MM-DD'));
        setCutofftime(moment.utc(editData?.cuttoffTime).format('HH:mm'));
        setStartdate(moment(editData?.startTime).format('YYYY-MM-DD'));
        setStartTime(moment.utc(editData?.startTime).format('HH:mm'));
      }
    }
  }, [editData, open]);

  const handleCancel = () => {
    onClose();
  };

  const onImageChange = (event) => {
    // console.log(event.target.files[0]);
    const { files } = event.target;
    if (files && files[0]) {
      let url = URL.createObjectURL(files[0]);
      // console.log(url);
      // setImage(url);
      UploadImage(url, files[0]);
    }
  };

  const onImageWebChange = (event) => {
    // console.log(event.target.files[0]);
    const { files } = event.target;
    if (files && files[0]) {
      let url = URL.createObjectURL(files[0]);
      // console.log(url);
      // setImage(url);
      UploadWebImage(url, files[0]);
    }
  };

  const onuserUpload = (event) => {
    // console.log(event.target.files[0]);
    const { files } = event.target;
    if (files && files[0]) {
      let url = URL.createObjectURL(files[0]);
      // console.log(url);
      // setImage(url);
      uploadUser(url, files[0]);
    }
  };

  const uploadUser = (url, files) => {
    var formdata = new FormData();
    formdata.append("file", files);
    var requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow",
    };
    let imgUrl = `${endPoints.apiBaseUrl}${endPoints.api.UPLOAD_BANNER}`;
    fetch(imgUrl, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log(result);
        setUserList(result.data);
      })
      .catch((error) => console.log("error", error));
  };

  // console.log("userlist",`${endPoints.apiBaseUrl}${userlist}`);

  const UploadImage = (url, files) => {
    setIsLoading(true);
    var formdata = new FormData();
    formdata.append("file", files);
    var requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow",
    };
    let imgUrl = `${endPoints.apiBaseUrl}${endPoints.api.UPLOAD_BANNER}`;
    fetch(imgUrl, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        // console.log(result);
        SuccesToast(result.message);
        setIsLoading(false);
        setImage(result.data);
      })
      .catch((error) => console.log("error", error));
  };


  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onload = (e) => {
      const text = e.target.result;
      // Assuming the CSV contains only one column of customer IDs
      const idsArray = text.split('\n').map(row => row.trim());
      const user_ids = idsArray.join(',');
      setCustomerIds(user_ids);

      // Log the concatenated customer IDs to the console
      // console.log("Customer IDs:", user_ids);
    };

    reader.readAsText(file);
  };


  const UploadWebImage = (url, files) => {
    setIsLoading(true);
    var formdata = new FormData();
    formdata.append("file", files);
    var requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow",
    };
    let imgUrl = `${endPoints.apiBaseUrl}${endPoints.api.UPLOAD_BANNER}`;
    fetch(imgUrl, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        SuccesToast(result.message);
        setIsLoading(false);
        setWebImage(result.data);
      })
      .catch((error) => console.log("error", error));
  };

  const handleOk = () => {
    if(title&&des&&image){ 
    let url = editData?.id
      ? `${endPoints.api.UPDATE_POPUP}`
      : `${endPoints.api.ADD_POPUP}`;

      //  const newids = `${endPoints.apiBaseUrl}${userlist}`

      // const idsArray = newids.split('\n').map(row => row.trim());
      // const concatenatedIds = idsArray.join(',');
      // setCustomerIds(concatenatedIds);
      // console.log("Customer IDs:", concatenatedIds);

      // "title":"Test tile","description":"Hi Tested","mobile_image":"mbimgae","web_image":"webimage","user_list":"user",
      // "link":"link","isActive":true,"login_attempt":2,"startTime":"2024-02-07T07:31:56.000+0000",
      // "cuttoffTime":"2024-02-07T07:31:56.000+0000","created_on":"2024-02-07T07:31:56.000+0000",
      // "updated_on":"2024-02-07T07:31:56.000+0000","id":1

    let payload = {
      title: title,
      description: des,
      mobile_image:image,
      web_image:webimage,
      user_list:editData?.id && customerIds ? customerIds  :  editData?.id && customerIds ==""?  editData.user_list : customerIds,
      sort:0,
      login_attempt:sort,
      link:link,
      startTime:startTiming,
      cuttoffTime:endTiming,
      isActive: isActive,
      // startdate:startdate,
      // starttime:startTime,
      // cutoffdate:cutoffdate,
      // cutofftime:cutofftime
    };

    // console.log("payload",webimage);

    if (editData?.id) {
      payload.id = editData.id;
    }
    setIsLoading(true);
    addData(url, payload)
      .then((response) => {
        setIsLoading(false);
        if (response.data.status === "success") {
          SuccesToast(response?.data?.message);
          // console.log("image",image);
          onClose();
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
        ErrorToast(error);
      });
    }
    else{
       ErrorToast("all fields are required");
    }
  };

  return (
    <Dialog
      xl={{ "& .MuiDialog-paper": { width: "80%", maxHeight: 435 } }}
      maxWidth="sm"
      open={open}
      {...other}
    >
      <DialogTitle>Banner Info </DialogTitle>

      <DialogContent dividers>
        <Toaster></Toaster>
        {isLoading && <Loader spinner={true} visible={isLoading} />}

        {/* <FormControl style={{ width: "10%", marginTop: "20px" }}></FormControl> */}

        <FormControl style={{ width: "100%", marginTop: "20px" }}>
          <TextField
            id="filled-required"
            variant="outlined"
            label="Message"
            value={des}
            onChange={(event) => {
              setDescription(event.target.value);
            }}
          />
        </FormControl>

        <FormControl style={{ width: "100%", marginTop: "20px" }}>
          <TextField
            id="filled-required"
            variant="outlined"
            label="Button name"
            value={title}
            onChange={(event) => {
              setTitle(event.target.value);
            }}
          />
        </FormControl>

        <FormControl style={{ width: "100%", marginTop: "30px" }}>
          <TextField
            id="filled-required"
            variant="outlined"
            label="Button Link"
            value={link}
            onChange={(event) => {
              setLink(event.target.value);
            }}
          />
        </FormControl>

        <FormControl style={{ width: "100%", marginTop: "20px" }}>
        <label>Login Attempts</label>
          <TextField
            id="filled-required"
            variant="outlined"
            // label="Cutoff Time"
            type="number"
            maxValue="5"
            minValue="1"
            value={sort}
            onChange={(event) => {
              setSort(event.target.value);
            }}
          />
        </FormControl>

        {/* <FormControl style={{ width: "10%", marginTop: "20px" }}></FormControl> */}
        

        <FormControl style={{ width: "100%", marginTop: "20px" }}>
          <label>Start Date</label>
        {/* <InputLabel htmlFor="my-input">Start Date</InputLabel> */}
          <TextField
            id="filled-required"
            variant="outlined"
            // label="Start Time"
            placeholder="start date"
            type="date"
            value={startdate}
            onChange={(event) => {
              setStartdate(event.target.value);
            }}
          />
        </FormControl>

        <FormControl style={{ width: "100%", marginTop: "20px" }}>
          <label>Start Time</label>
        {/* <InputLabel htmlFor="my-input">Start Date</InputLabel> */}
          <TextField
            id="filled-required"
            variant="outlined"
            // label="Start Time"
            placeholder="start date"
            type="time"
            value={startTime}
            onChange={(event) => {
              setStartTime(event.target.value);
            }}
          />
        </FormControl>

        {/* <FormControl style={{ width: "10%", marginTop: "20px" }}></FormControl> */}

        <FormControl style={{ width: "100%", marginTop: "20px" }}>
        <label>Cutoff Date</label>
          <TextField
            id="filled-required"
            variant="outlined"
            // label="Cutoff Date"
            type="date"
            value={cutoffdate}
            onChange={(event) => {
              setCutoffdate(event.target.value);
            }}
          />
        </FormControl>
        

        <FormControl style={{ width: "100%", marginTop: "20px" }}>
        <label>Cutoff Time</label>
          <TextField
            id="filled-required"
            variant="outlined"
            // label="Cutoff Time"
            type="time"
            value={cutofftime}
            onChange={(event) => {
              setCutofftime(event.target.value);
            }}
          />
        </FormControl>

        {/* <FormControl style={{ width: "10%", marginTop: "20px" }}></FormControl> */}

        <label style={{marginTop:"25px"}}>Mobile Image</label> 
        <Form.Control
        style={{marginBottom:"20px",width: "100%"}} 
        id="filled-required"
        variant="outlined"
        label="image"
        // value={image}
        name={image}
        onChange={onImageChange}
        type="file" 
        />

        <label style={{marginTop:"5px"}}>Web Image</label> 
        <Form.Control
        style={{marginBottom:"20px",width: "100%"}} 
        id="filled-required"
        variant="outlined"
        label="image"
        // value={image}
        name={webimage}
        onChange={onImageWebChange}
        type="file" 
        />

        {/* <label style={{marginTop:"5px"}}>Upload User List</label> 
        <Form.Control
        style={{marginBottom:"20px",width: "100%"}} 
        id="filled-required"
        variant="outlined"
        label="image"
        // value={image}
        name={userlist}
        onChange={onuserUpload}
        type="file" 
        /> */}

    <label style={{marginTop:"5px"}}>Upload User List</label> 
        <Form.Control
        style={{marginBottom:"20px",width: "100%"}} 
        id="filled-required"
        variant="outlined"
        label="image"
        // value={image}
        name={userlist}
        type="file" 
        onChange={handleFileUpload} 
        accept=".csv"
        />

        <FormControlLabel
          control={
            <Switch
              name="active"
              value={isActive}
              onClick={() => {
                setIsActive(!isActive);
              }}
              defaultChecked={isActive}
            />
          }
          labelPlacement="start"
          label="Active"
        />

        {/* <FormControl style={{ width: "100%", marginTop: "20px" }}>
          <TextField
            id="filled-required"
            variant="outlined"
            label="Price"
            value={price}
            onChange={(event) => {
              setPrice(event.target.value);
            }}
          />
        </FormControl>
        <FormControl style={{ width: "100%", marginTop: "20px" }}>
          <TextField
            id="filled-required"
            variant="outlined"
            label="Code"
            value={code}
            //  type="number"
            InputLabelProps={{
              shrink: true,
            }}
            onChange={(event) => {
              setCode(event.target.value);
            }}
          />
        </FormControl>

        <FormControl style={{ width: "100%", marginTop: "20px" }}>
          <TextField
            id="filled-required"
            variant="outlined"
            label="Player Count"
            value={playerCount}
            onChange={(event) => {
              setPlayerCount(event.target.value);
            }}
          />
        </FormControl> */}
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleCancel}>
          Cancel
        </Button>
        <Button onClick={handleOk}>Ok</Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreatePopup;
